import React, { useLayoutEffect, useState } from "react";
import HelperTip from "components/HOCS/HelperTip";
import HlpDragAvatar from "components/HelpSlides/Spaces/HlpDragAvatar";
import { FM_DRAGAVATAR } from "helpers/freshman";
import ReactDOM from "react-dom";
import { myCircle } from "space/spaceVars";

const DragAvatarHelper = () => {
  window.efs_debug && window.log("DRAGAVATAR LOADED");
  const [xPos, setXpos] = useState(100);
  const [yPos, setYpos] = useState(500);
  // finding position of myCircle
  const determinePositions = () => {
    if (!myCircle) {
      console.error("Could not find myCircle");
      return;
    }
    let { right, height, top } = myCircle.getBoundingClientRect();
    setXpos(right);
    setYpos(top + height / 2);
  };
  useLayoutEffect(() => {
    determinePositions();
    window.addEventListener("resize", determinePositions);
    return () => {
      window.removeEventListener("resize", determinePositions);
    };
  }, []);
  return ReactDOM.createPortal(
    <HelperTip
      component={<HlpDragAvatar />}
      code={FM_DRAGAVATAR}
      placement="right"
      style={{ width: "420px", height: "444px" }}
      offset={[0, 50]}
      arrowWhite
      lazy
    >
      <div
        className="dragAvatarHelperBox"
        style={{ position: "absolute", top: `${yPos}px`, left: `${xPos}px` }}
      ></div>
    </HelperTip>,
    document.querySelector("#modal")
  );
};

export default DragAvatarHelper;
